export class Reject {
    machineSerialNumber: string;
    machineInstallationName: string;
    dateTime: Date;
    cause: string;
    count: number;

    constructor() {
        this.machineSerialNumber = null;
        this.machineInstallationName = null;
        this.dateTime = null;
        this.cause = null;
        this.count = 0;
    }

    public parse(obj: any) {
        if (obj.MachineSerialNumber) this.machineSerialNumber = obj.MachineSerialNumber;
        if (obj.MachineInstallationName) this.machineInstallationName = obj.MachineInstallationName;
        if (obj.DateTime) this.dateTime = new Date(obj.DateTime);
        if (obj.Cause) this.cause = obj.Cause;
        if (obj.Count) this.count = obj.Count;
    }
}

export const familyLabelToIndex = new Map<string, number>([
    ["REJECT_FAMILY_FILTER", 0],
    ["REJECT_FAMILY_USER", 1],
    ["REJECT_FAMILY_SENSOR", 2],
    ["REJECT_FAMILY_MACHINE", 3],
    ["REJECT_FAMILY_BANKNOTE", 4],
    ["REJECT_FAMILY_COIN", 5],
    ["REJECT_FAMILY_OTHER", 6],
]);
